import { useCallback, useMemo } from "react";
import type IPipedriveOrganization from "../../interfaces/IPipedriveOrganization";
import type IProperty from "../../interfaces/IProperty";
import type { IPropertyAiGrade } from "../../services/propertyAiGradeApiService";
import usePropertyAiGrade from "../usePropertyAiGrade";
import type { IEstimates } from "../usePropertyEstimates";
import { buildBoeModelFromProperty } from "./boeMappings";
import { useBoeGenerator } from "./useBoeGenerator";

export function usePropertyBoeGenerator(property: IProperty) {
    const { aiGrade, isLoading, isError, fetchAiGrade } = usePropertyAiGrade(property);
    const dataSource = useMemo(() => ({ data: aiGrade, isLoading, isError, fetch: fetchAiGrade }), [aiGrade, isLoading, isError, fetchAiGrade]);

    const buildModel = useCallback(
        (aiGrade: IPropertyAiGrade, estimates: IEstimates, initials: string, pipedriveOrganizations: IPipedriveOrganization[]) =>
            buildBoeModelFromProperty(property, estimates, aiGrade, initials, pipedriveOrganizations),
        [property]
    );

    return useBoeGenerator(property, dataSource, buildModel);
}
